// extracted by mini-css-extract-plugin
export default {"preformatted":"kFL6oC5DCNhXxhPfcmQH","uppercase":"HUKmX9ibOV4MJaHfbzWB","result":"EVeU44oXGmVXyoGsi_LJ"};